























import { Component, Prop, Vue } from "vue-property-decorator";
import { card, comment, user } from "../board";
import { Action, Mutation, State } from "vuex-class";
import moment from "moment";

@Component
export default class Comment extends Vue {
  @Action deleteComment;
  @Mutation removeComment;
  @Prop() card!: card;
  @Prop() comment!: comment;
  @State("myUser") storeMyUser: user;
  get cardDate() {
    if (this.comment.createdOn) {
      const formattedDate = moment(this.comment.createdOn.toString()).format(
        "MMM DD, YYYY"
      );
      return formattedDate;
    }
    return "";
  }

  get isCurrentUser() {
    return (
      this.comment.createdBy.email.localeCompare(this.storeMyUser.email) === 0
    );
  }

  deleteThisComment() {
    this.deleteComment({ comment: this.comment, board: this.card.board });
    this.removeComment(this.comment);
  }
}
